/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { VspCreation, VspCreationInfo, VspData, VspHeader, VspSection } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class VspClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Vsp
   * @summary Создание ВСП на скважинах
   * @request POST:/geology/vsp
   * @secure
   */
  vspAddVsp = (data: VspCreation[], params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/vsp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Создание ВСП на скважине
   * @request POST:/geology/vsp/with_result
   * @secure
   */
  vspAddVspWithResult = (data: VspCreation, params: RequestParams = {}) =>
    this.http.request<VspCreationInfo, any>({
      path: `/geology/vsp/with_result`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Получить список ВСП для скважины
   * @request GET:/geology/vsp/well/{wellId}
   * @secure
   */
  vspGetVspsGuidForWell = (wellId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/vsp/well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Получить список заголовков ВСП для скважины
   * @request GET:/geology/vsp/well/{wellId}/head
   * @secure
   */
  vspGetVspsHeaderGuidForWell = (wellId: string, params: RequestParams = {}) =>
    this.http.request<VspHeader[], any>({
      path: `/geology/vsp/well/${wellId}/head`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Получить данные ВСП с указанным идентификатором
   * @request GET:/geology/vsp/{vspId}
   * @secure
   */
  vspGetVspDataById = (vspId: string, params: RequestParams = {}) =>
    this.http.request<VspData, any>({
      path: `/geology/vsp/${vspId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Получить срезку ВСП с указанным идентификатором
   * @request GET:/geology/vsp/{vspId}/{attributeSectionName}
   * @secure
   */
  vspGetVspSectionById = (
    vspId: string,
    attributeSectionName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<VspSection, any>({
      path: `/geology/vsp/${vspId}/${attributeSectionName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Привязать существующий ВСП к другой скважине
   * @request POST:/geology/vsp/{vspId}/attach-to-well/{wellId}
   * @secure
   */
  vspAttachVspToWell = (vspId: string, wellId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/geology/vsp/${vspId}/attach-to-well/${wellId}`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Vsp
   * @summary Получить список допустимых атрибутов для создания срезки
   * @request GET:/geology/vsp/attributes
   * @secure
   */
  vspGetAttributes = (params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/vsp/attributes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
